module.exports = __webpack_public_path__ + "img/150.4cc0029c.png";